import { BasicFirstSessionTrackingCommand } from "./basis/BasicFirstSessionTrackingCommand";
import { TrackingCache } from "./../../../../tracking/TrackingCache";
import { TrackingEventIds } from "./../../../../tracking/constants/TrackingEventIds";
import { WorldAssignmentTrackingEvent } from "./../../../../tracking/WorldAssignmentTrackingEvent";
import { WorldAssignment } from "@goodgamestudios/world-assignment";

/**
 * - fires the world assignment tracking event
 */
export class BasicWorldAssignmentTrackingCommand extends BasicFirstSessionTrackingCommand {
    public execute(commandVars: any = null): void {
        if (!this.commandIsAllowed) {
            return;
        }
        const worldAssignmentFacade = (window.ggs.worldAssignment as WorldAssignment).facade;
        let worldAssignmentTrackingEvent: WorldAssignmentTrackingEvent = <WorldAssignmentTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.WORLD_ASSIGNMENT);

        worldAssignmentTrackingEvent.accountId = this.env.accountId;
        worldAssignmentTrackingEvent.countryDetectionFactor = worldAssignmentFacade.detectionFactor;
        worldAssignmentTrackingEvent.country = worldAssignmentFacade.currentCountry;
        worldAssignmentTrackingEvent.campaignVars = this.env.campainVars;
        worldAssignmentTrackingEvent.websiteId = this.env.urlVariables.websiteId;

        TrackingCache.getInstance().sendEvent(TrackingEventIds.WORLD_ASSIGNMENT);
    }
}
